import React, { useEffect, useState } from "react";
import { FiMenu, FiX } from "react-icons/fi";
import "../styles/Navbar.css";

const navLinks = [
  { label: "Home", path: "/", homeSection: "home" },
  { label: "Courses", path: "/courses", homeSection: "courses" },
  { label: "Testimonials", path: "/reviews", homeSection: "reviews" },
  { label: "About", path: "/about", homeSection: "about" },
  { label: "Blog", path: "/blog", homeSection: "blog" },
  { label: "FAQ", path: "/faq", homeSection: "faq" },
  { label: "Contact", path: "/contact", homeSection: "contact" },
];

const sectionIds = navLinks.map((link) => link.homeSection).filter(Boolean);

function scrollToSection(sectionId) {
  if (sectionId === "home") {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
}

function getActiveSectionFromScroll() {
  const offset = 130;
  let current = "home";

  for (const id of sectionIds) {
    const el = document.getElementById(id);
    if (!el) continue;
    if (el.getBoundingClientRect().top <= offset) {
      current = id;
    }
  }

  return current;
}

export default function Navbar({ currentPath, navigate }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    if (currentPath !== "/") return undefined;

    const hash = window.location.hash.replace("#", "");
    if (hash && sectionIds.includes(hash)) {
      setActiveSection(hash);
    }

    const onScroll = () => {
      setActiveSection(getActiveSectionFromScroll());
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("hashchange", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("hashchange", onScroll);
    };
  }, [currentPath]);

  const isLinkActive = (link) => {
    if (currentPath === "/") {
      return link.homeSection === activeSection;
    }
    return currentPath === link.path;
  };

  const handleClick = (e, link) => {
    e.preventDefault();
    setMobileOpen(false);

    if (link.homeSection) {
      if (currentPath === "/") {
        setActiveSection(link.homeSection);
        scrollToSection(link.homeSection);
        return;
      }
      navigate(`/#${link.homeSection}`);
      return;
    }

    navigate(link.path);
  };

  return (
    <header className="navbar-wrap">
      <div className="navbar-pill">
        <button
          type="button"
          className="navbar-brand"
          onClick={(e) => handleClick(e, navLinks[0])}
          aria-label="Confideo Cloud & Code home"
        >
          <span className="navbar-logo-ring">
            <img src="/images/c3-logo.png" alt="Confideo Cloud & Code" className="navbar-logo-img" />
          </span>
          <span className="navbar-brand-text">
            <span className="navbar-brand-name">Confideo Cloud & Code</span>
            <span className="navbar-brand-tag">Learn. Build. Deploy. Grow.</span>
          </span>
        </button>

        <nav className="navbar-desktop">
          {navLinks.map((link) => (
            <a
              key={link.path}
              href={link.homeSection ? `/#${link.homeSection}` : link.path}
              onClick={(e) => handleClick(e, link)}
              className={isLinkActive(link) ? "active" : ""}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="navbar-actions">
          <button
            type="button"
            className="nav-demo-btn"
            onClick={() =>
              window.open("https://www.youtube.com/@confideocloudcode", "_blank")
            }
          >
            Free Demo
          </button>

          <button
            type="button"
            className="navbar-toggle"
            onClick={() => setMobileOpen((v) => !v)}
            aria-expanded={mobileOpen}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <FiX size={22} /> : <FiMenu size={22} />}
          </button>
        </div>

        {mobileOpen && (
          <div className="navbar-mobile-menu">
            {navLinks.map((link) => (
              <a
                key={link.path}
                href={link.homeSection ? `/#${link.homeSection}` : link.path}
                onClick={(e) => handleClick(e, link)}
                className={isLinkActive(link) ? "active" : ""}
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
